import { channels, subChannels } from './Channels'
import { utils } from '../utils/utils';
import { paymentMethods } from './PaymentMethods';
import { hasTerminalQrPayment } from '../utils/payment-utils';
import { PaymentStates } from './PaymentStates';
import { StatesColors } from '@arredo/reactjs-ui';

export const headers = [
  'Id',
  'Cod. Vendedor',
  'Canal de venta',
  'Cod. Facturacion',
  'Estado',
  'Cliente',
  'Creado'
];

export const columns = [
  {
    field: 'refId',
    header: 'ID',
    sizes: { xs: 1 }
  },
  {
    field: 'branchCode',
    header: 'Cod. Local',
    sizes: { xs: 1 }
  },
  {
    field: 'order',
    header: 'Canal',
    translate: (order) => `${channels.labels[order.channel]} | ${subChannels.labels[order.subChannel]}`
  },
  {
    field: 'sellerCode',
    tooltip: (sale) => sale?.seller?.userName,
    header: 'Vendedor',
    sizes: { xs: 1 }
  },
  {
    field: 'order',
    header: 'Cod. Factura',
    type: 'number',
    translate: (order) => {
      const voucher = order.vouchers?.find(v => v.type === order.invoiceType);
      if (!voucher) return '';

      return utils.formatVoucher(order.country, voucher.type, voucher.billingCode, voucher.number)
    }
  },
  {
    field: 'state',
    header: 'Estado',
    type: 'chip',
    sx: (row) => StatesColors[row.state],
    translate: (state) => statesTranslate[state]
  },
  {
    field: 'customer',
    header: 'Cliente',
    sizes: { xs: 2 },
    translate: (customer) => !!customer && !!customer.lastName
      ? `${customer.lastName ? customer.lastName + ', ' : ''} ${customer.firstName}`
      : customer.firstName
        ? `${customer.firstName}`
        : `Cliente sin cargar`
  },
  {
    field: 'created',
    header: 'Creado',
    type: 'date'
  }
];

export const modelCustomer = {
  id: 0,
  status: '',
  firstName: '',
  lastName: '',
  country: '',
  birthDate: null,
  gender: '',
  phone: '',
  email: '',
  documentType: '',
  documentNumber: '',
  active: true
}

export const model = {
  id: '',
  billingCode: 0,
  sellerCode: '',
  branchCode: '',
  customer: {},
  transactionId: '',
  invoiceId: '',
  channel: '',
  state: '',
  country: '',
  currency: '',
  items: [],
  history: [],
  shippingData: {},
  created: '',
  amount: 0,
  discount: 0,
  refund: 0
};

export const OrderStates = {
  Initiated: 'Initiated',
  PaymentInitiated: 'PaymentInitiated',
  PaymentProcessed: 'PaymentProcessed',
  PaymentRefused: 'PaymentRefused',
  Canceled: 'Canceled',
  Invoiced: 'Invoiced',
  Refunded: 'Refunded',
  Voided: 'Voided',
  PartiallyRefunded: 'PartiallyRefunded',
  InvoiceInitiated: 'InvoiceInitiated',
  InvoicedWithErrors: 'InvoicedWithErrors',
  Replaced: 'Replaced',
  InvoiceProcessing: 'InvoiceProcessing',
  OperationProcessing: 'OperationProcessing',
  OperationRejected: 'OperationRejected'
}

export const OrderOperationStates = {
  Initialized: 'Initialized',
  Approved: 'Approved',
  PaymentProcesed: 'PaymentProcesed',
  RecordedMovements: 'RecordedMovements',
  RecordedStockMovements: 'RecordedStockMovements',
  PackageCreated: 'PackageCreated',
  ProcessingPayment: 'ProcessingPayment',
  PaymentRejected: 'PaymentRejected',
  Cancelled: 'Cancelled'
}

export const statesTranslate = {
  Initiated: 'Iniciada',
  PaymentInitiated: 'Pago Iniciado',
  PaymentProcessed: 'Pago Procesado',
  PaymentRefused: 'Pago Rechazado',
  Canceled: 'Cancelada',
  Invoiced: 'Facturada',
  Refunded: 'Devuelta',
  Voided: 'Devuelto Total',
  PartiallyRefunded: 'Parcialmente Devuelta',
  InvoiceInitiated: 'Factura Iniciada',
  InvoicedWithErrors: 'Facturada con errores',
  Replaced: 'Reemplazada',
  InvoiceProcessing: 'Procesando Factura',
  OperationProcessing: 'Procesando Operación',
  OperationRejected: 'Operación Rechazada'
}

export const statesSelect = [
  { value: OrderStates.Initiated, label: statesTranslate.Initiated },
  { value: OrderStates.PaymentInitiated, label: statesTranslate.PaymentInitiated },
  { value: OrderStates.PaymentProcessed, label: statesTranslate.PaymentProcessed },
  { value: OrderStates.PaymentRefused, label: statesTranslate.PaymentRefused },
  { value: OrderStates.Canceled, label: statesTranslate.Canceled },
  { value: OrderStates.InvoiceInitiated, label: statesTranslate.InvoiceInitiated },
  { value: OrderStates.InvoicedWithErrors, label: statesTranslate.InvoicedWithErrors },
  { value: OrderStates.Invoiced, label: statesTranslate.Invoiced },
  { value: OrderStates.Refunded, label: statesTranslate.Refunded },
  { value: OrderStates.PartiallyRefunded, label: statesTranslate.PartiallyRefunded },
  { value: OrderStates.Voided, label: statesTranslate.Voided },
  { value: OrderStates.InvoiceProcessing, label: statesTranslate.InvoiceProcessing },
  { value: OrderStates.OperationProcessing, label: statesTranslate.OperationProcessing },
  { value: OrderStates.OperationRejected, label: statesTranslate.OperationRejected },
];

export const title = 'Listado de Ventas';

export const CanPrint = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  order.vouchers &&
  order.vouchers.length > 0 &&
  order.subChannel !== subChannels.values.FacturaManual

export const CanInvoice = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  (order?.state === OrderStates.PaymentProcessed || order?.state === OrderStates.InvoicedWithErrors)

export const CanVoid = (order, currentBranch) =>
  !order.wasReplaced &&
  (order.branchCode === currentBranch.code || (order.businessId === currentBranch.businessId &&
    (order.channel === channels.values.Ecommerce ||
      order.channel === channels.values.Marketplace
    ))) &&
  (order?.state === OrderStates.PaymentProcessed || order?.state === OrderStates.Invoiced)

export const CanRefund = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  order.round === 0 &&
  (order?.state === OrderStates.Invoiced || order?.state === OrderStates.PartiallyRefunded) &&
  !(order.itemsToReturn.length > 0 && !order.isChangeOrder) &&
  !hasTerminalQrPayment(order) &&
  CanRefundItems(order.items)

/**
 * Indica si la orden quedó con pagos rechazados/cancelados pero con al menos un pago ya aprobado.
 * No hay soporte para rearmar los pagos en el carrito en esa condición: la única salida es
 * cancelar la venta desde el detalle, que dispara la devolución de lo ya cobrado.
 */
export const IsPaymentRefusedWithApprovedPayment = (order) =>
  order?.state === OrderStates.PaymentRefused &&
  (order?.payments?.some(p => p.state === PaymentStates.Approved) ?? false)

export const CanEdit = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  order?.subChannel !== subChannels.values.AppInStore &&
  (order?.state === OrderStates.Initiated || order?.state === OrderStates.PaymentRefused) &&
  !IsPaymentRefusedWithApprovedPayment(order)

export const CanChange = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  (order?.state === OrderStates.Invoiced || order?.state === OrderStates.PartiallyRefunded) &&
  order.itemsToReturn.length <= 0 &&
  !hasTerminalQrPayment(order) &&
  CanRefundItems(order.items)


export const CanCreateCI = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  (order?.state === OrderStates.Invoiced || order?.state === OrderStates.PartiallyRefunded) &&
  !hasTerminalQrPayment(order) &&
  CanRefundItems(order.items)

export const CanChangeOtherBranch = (order, currentBranch) =>
  order.branchCode !== currentBranch.code &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  order.businessId === currentBranch.businessId &&
  (order?.state === OrderStates.Invoiced || order?.state === OrderStates.PartiallyRefunded) &&
  order.itemsToReturn.length <= 0 &&
  !hasTerminalQrPayment(order) &&
  CanRefundItems(order.items)

export const CanContinuePayment = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  order?.subChannel !== subChannels.values.AppInStore &&
  order.state === OrderStates.PaymentInitiated

export const CanCancelPayment = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  order?.subChannel !== subChannels.values.AppInStore &&
  order.state === OrderStates.PaymentInitiated

export const CanRetryOperation = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  order.state === OrderStates.OperationRejected

export const CanCancelOperation = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  (order.state === OrderStates.OperationProcessing || order.state === OrderStates.OperationRejected) &&
  order.operations.some(o => o.state !== OrderOperationStates.Approved && o.state !== OrderOperationStates.Cancelled)

export const CanRedirecToRefundView = (order) =>
  (order.channel === channels.values.Tienda || order.channel !== channels.values.Franchises) &&
  (order.state === OrderStates.OperationProcessing || order.state === OrderStates.OperationRejected) &&
  order.operations.some(o => o.state !== OrderOperationStates.Approved && o.state !== OrderOperationStates.Cancelled)

export const CanCancelSale = (order, currentBranchCode) =>
  order.branchCode === currentBranchCode &&
  (order.channel === channels.values.Tienda || order.channel === channels.values.Franchises) &&
  order?.subChannel !== subChannels.values.AppInStore &&
  (order.state === OrderStates.PaymentInitiated ||
    order.state === OrderStates.PaymentProcessed ||
    order.state === OrderStates.PaymentRefused)

const CanRefundItems = items =>
  items.some(i => i.quantity > i.refundedQuantity)

/**
 * Indica si en este momento hay items publicados y pendientes de interacción física
 * en la terminal integrada.
 * Es el único estado en el que tiene sentido llevar al usuario a la vista de
 * devoluciones de payment-web como consecuencia de una acción que acabamos de ejecutar:
 * si la operación ya no está procesándose, no queda nada para operar en la terminal.
 */
export const HasPendingTerminalItems = (order) =>
  order?.state === OrderStates.OperationProcessing

export const onRedirectToRefundView = (order) => {
    const paymentData = order.payments.find(p => p.isTerminal && p.paymentMethodType === paymentMethods.Posnet);
    const operation = order.operations.find(o => o.state !== OrderOperationStates.Approved && o.state !== OrderOperationStates.Cancelled);
    if (paymentData && operation) {
        window.location.href = `${paymentData.refundUrl}${operation.id}`;
    }
}
